module.exports = __webpack_public_path__ + "static/media/call.319d45b4.png";